class ProductForm extends HTMLElement {
  constructor() {
    super();  
    this.setForm(); 
    this.upsellBlocks = [...document.querySelectorAll('upsell-block-element')];
    this.upsellPopUp = document.querySelector('upsells-pop-up-element');
    this.cartNotification = document.querySelector('cart-notification');
    if (window.cartNotificationMode == "drawer_mode"){
      this.drawer = document.querySelector('cart-drawer');
    }
    this.upsellElement = [...document.querySelectorAll('upsell-element')];
  }
  setForm(){
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    if (window.cartNotificationMode == "under_cart_icon"){
      this.cartNotification.setActiveElement(document.activeElement);
    }    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
  
    var upsellBlocksBody = this.upsellBlocks.length > 0 ? this.upsellBlocks.filter((upsellBlock)=>{
      return upsellBlock.isChecked();
    }).map((upsellBlock)=>{
      return upsellBlock.getUpsellFormJson();
    }):[];
    var upsellPopupBody = this.upsellPopUp ? this.upsellPopUp.getActiveUpsellsJson():[];

    const bodyComplete = [...upsellBlocksBody,...upsellPopupBody,JSON.parse(serializeForm(this.form))]
    var body =  JSON.stringify({
      items:  bodyComplete,
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    var requestObject = { ...fetchConfig('javascript'), body }

    fetch(`${routes.cart_add_url}`, requestObject)
      .then((response) => response.json())
      .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(async() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        if (window.cartNotificationMode == "drawer_mode"){
          await this.drawer.updateCartDrawer();
          this.upsellElement.forEach((upsellElement)=>upsellElement.updateUpsells());
          // WS7 (resolve A16) — pass the Add-to-Cart button so closeDrawer
          // can restore focus to it on Escape, even when the click did not
          // focus the button (Chromium mouse-click focus suppression).
          this.drawer.openDrawer(submitButton);
         }else if (window.cartNotificationMode == "redirect_to_cart"){
          var utm = utmSetters();
          if (utm) {
            window.location.replace(`${window.location.origin}/cart/?`+utm);
          }else{
            window.location.replace(`${window.location.origin}/cart`);
          }
         } 
      });
      
  }
}

customElements.define('product-form', ProductForm);
